(function () {
  'use strict';

  if (window.__ER_RESERVATION_DROPDOWN_SOURCE_FIX__) return;
  window.__ER_RESERVATION_DROPDOWN_SOURCE_FIX__ = true;

  var style = document.createElement('style');
  style.id = 'er-reservation-dropdown-style';
  style.textContent = [
    '#er-resv #er-step-h{gap:8px}',
    '#er-resv #er-step-h .resv-t{align-items:center;gap:12px;margin-bottom:0}',
    '#er-resv #er-step-h .resv-t i{font-size:.7rem;line-height:1.3;color:var(--er-ink-faint)}',
    '#er-resv #er-slots.er-reservation-dropdown{display:block;width:min(100%,360px);max-width:360px}',
    '#er-resv #er-slots.er-reservation-dropdown>.slot,#er-resv #er-slots.er-reservation-dropdown>.slot-lbl{display:none!important}',
    '#er-resv .er-reservation-time-field{display:block;width:100%;margin:0}',
    '#er-resv .er-reservation-time-control{position:relative;display:block;width:100%;border-bottom:1px solid color-mix(in srgb,var(--er-accent) 58%,var(--er-line));transition:border-color .2s var(--er-ease)}',
    '#er-resv .er-reservation-time-control:hover,#er-resv .er-reservation-time-control:focus-within{border-bottom-color:var(--er-accent)}',
    '#er-resv .er-reservation-time-select{-webkit-appearance:none;appearance:none;width:100%;height:44px;min-height:44px;padding:0 38px 0 2px;border:0;border-radius:0;background:transparent;color:var(--er-ink);outline:0;font:inherit;font-size:1rem;font-weight:500;line-height:1.2;font-variant-numeric:tabular-nums;letter-spacing:0;cursor:pointer}',
    '#er-resv .er-reservation-time-select option{background:var(--er-surface);color:var(--er-ink);font-size:.92rem}',
    '#er-resv .er-reservation-time-control:before,#er-resv .er-reservation-time-control:after{content:"";position:absolute;right:8px;width:6px;height:6px;border-right:1.5px solid var(--er-ink);border-bottom:1.5px solid var(--er-ink);pointer-events:none;opacity:.82}',
    '#er-resv .er-reservation-time-control:before{top:13px;transform:rotate(225deg)}',
    '#er-resv .er-reservation-time-control:after{top:23px;transform:rotate(45deg)}',
    '#er-resv .er-reservation-time-help{max-width:360px;margin:6px 0 0;font-size:.67rem;line-height:1.4;color:var(--er-ink-faint)}',
    '#er-resv .er-reservation-time-bridge{display:none!important}',
    '@media(max-width:900px){#er-resv #er-slots.er-reservation-dropdown{width:min(100%,420px);max-width:420px}}',
    '@media(max-width:620px){#er-resv #er-step-h .resv-t{align-items:flex-start;flex-wrap:wrap;gap:4px 10px}#er-resv #er-slots.er-reservation-dropdown{width:100%;max-width:none}#er-resv .er-reservation-time-select{height:46px;min-height:46px;font-size:.96rem}#er-resv .er-reservation-time-help{max-width:none;font-size:.65rem}}'
  ].join('');
  document.head.appendChild(style);

  function enhanceSlots(slots) {
    if (!slots || !slots.isConnected) return;

    var buttons = Array.prototype.slice.call(slots.querySelectorAll('button.slot[data-t]'));
    if (!buttons.length) return;

    var labels = Array.prototype.slice.call(slots.querySelectorAll('.slot-lbl'));
    var closeByChat = labels.some(function (node) {
      return (node.textContent || '').toLowerCase().indexOf('cierre') !== -1;
    });

    var selectedButton = buttons.find(function (button) {
      return button.getAttribute('aria-pressed') === 'true';
    });

    var field = document.createElement('div');
    field.className = 'er-reservation-time-field';

    var control = document.createElement('span');
    control.className = 'er-reservation-time-control';

    var select = document.createElement('select');
    select.className = 'er-reservation-time-select';
    select.setAttribute('aria-label', 'Horario de la reserva');
    select.setAttribute('data-er-reservation-time-select', '');

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.textContent = 'Seleccioná un horario';
    select.appendChild(placeholder);

    buttons.forEach(function (button) {
      var option = document.createElement('option');
      option.value = button.getAttribute('data-t') || '';
      option.textContent = (button.textContent || '').trim() + ' hs';
      select.appendChild(option);
    });

    select.value = selectedButton ? (selectedButton.getAttribute('data-t') || '') : '';

    control.appendChild(select);
    field.appendChild(control);

    var fragment = document.createDocumentFragment();
    fragment.appendChild(field);

    if (closeByChat) {
      var help = document.createElement('p');
      help.className = 'er-reservation-time-help';
      help.textContent = 'Los últimos horarios se confirman por WhatsApp.';
      fragment.appendChild(help);
    }

    slots.replaceChildren(fragment);

    select.addEventListener('change', function () {
      if (!select.value) return;

      var bridge = document.createElement('button');
      bridge.type = 'button';
      bridge.className = 'er-reservation-time-bridge';
      bridge.setAttribute('data-t', select.value);
      bridge.setAttribute('aria-hidden', 'true');
      bridge.tabIndex = -1;
      slots.appendChild(bridge);
      bridge.click();
      if (bridge.isConnected) bridge.remove();
    });
  }

  function attach() {
    var slots = document.querySelector('#er-resv #er-slots');
    if (!slots) return;

    slots.classList.add('er-reservation-dropdown');

    if (slots.dataset.erReservationDropdownObserved !== '1') {
      slots.dataset.erReservationDropdownObserved = '1';
      var observer = new MutationObserver(function () {
        enhanceSlots(slots);
      });
      observer.observe(slots, { childList: true });
    }

    enhanceSlots(slots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  } else {
    attach();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(attach, 0);
  });
})();
